/**
 * Dashboard runtime configuration.
 *
 * The dashboard is a read-only static artifact: all values are either
 * hard-coded UI constants or read from the brain's exported snapshot.
 * There are no secrets and no environment-specific runtime behavior
 * beyond the snapshot URL.
 */
export const config = {
  /**
   * Snapshot source.
   *
   * Defaults to the live brain's `/snapshot` endpoint. Override at build time
   * via the `VITE_AMOEBA_SNAPSHOT_URL` environment variable, e.g.:
   *   VITE_AMOEBA_SNAPSHOT_URL=./snapshot.json npm run build
   */
  snapshotUrl:
    import.meta.env?.VITE_AMOEBA_SNAPSHOT_URL ??
    'https://amoeba-brain.quan2024.workers.dev/snapshot',
  /** Polling interval in milliseconds. */
  pollIntervalMs: 30_000,
  /** A snapshot older than this is shown as stale rather than live. */
  staleThresholdMs: 5 * 60 * 1_000,
  /** Base block-explorer URL for the wallet address. */
  explorerBaseUrl: 'https://basescan.org/address',
} as const;
